import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('bb_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

function logoutAndRedirect() {
  localStorage.removeItem('bb_token');
  localStorage.removeItem('bb_refresh_token');
  window.location.href = '/login';
}

let refreshPromise = null;

api.interceptors.response.use(
  r => r,
  async err => {
    const original = err.config;
    const isAuthEndpoint = original?.url?.startsWith('/auth/login') || original?.url?.startsWith('/auth/refresh');

    if (err.response?.status === 401 && !original._retried && !isAuthEndpoint) {
      const refreshToken = localStorage.getItem('bb_refresh_token');
      if (!refreshToken) {
        logoutAndRedirect();
        return Promise.reject(err);
      }

      original._retried = true;
      try {
        // Dedupe concurrent refreshes triggered by parallel requests.
        refreshPromise ??= axios
          .post(`${API_BASE}/auth/refresh`, { refresh_token: refreshToken })
          .finally(() => { refreshPromise = null; });

        const { data } = await refreshPromise;
        localStorage.setItem('bb_token', data.access_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (refreshErr) {
        logoutAndRedirect();
        return Promise.reject(refreshErr);
      }
    }

    if (err.response?.status === 401) {
      logoutAndRedirect();
    }
    return Promise.reject(err);
  }
);

export default api;
